const statuses = {
  reserved: {
    en: 'Reserved',
    ar: 'تم إتمام الحجز',
    zh: 'Reserved',
  },
  orderEligible: {
    en: 'Ready to order',
    ar: 'جاهز للطلب ',
    zh: 'Ready to order',
  },
  ordered: {
    en: 'Ordered',
    ar: 'تم الطلب',
    zh: 'Ordered',
  },
  readyForPayment: {
    en: 'Ready for payment',
    ar: 'Ready for payment',
    zh: 'Ready for payment',
  },
  paid: {
    en: 'Paid',
    ar: 'Paid',
    zh: 'Paid',
  },
  fulfilled: {
    en: 'Delivered',
    ar: 'Delivered',
    zh: 'Delivered',
  },
  fullyBooked: {
    en: 'Reservations closed',
    ar: 'محجوزة بالكامل',
    zh: 'Reservations closed',
  },
  orderProcessing: {
    en: 'Order processing',
    ar: 'Order processing',
    zh: 'Order processing',
  },
  cancellationRequested: {
    en: 'Cancellation requested',
    ar: 'Cancellation requested',
    zh: 'Cancellation requested',
  },
  canceled: {
    en: 'Canceled',
    ar: 'Canceled',
    zh: 'Canceled',
  },
  changeRequested: {
    en: 'Change Requested',
    ar: 'Change Requested',
    zh: 'Change Requested',
  },
  design: {
    en: 'Saved',
    ar: 'Saved',
    zh: 'Saved',
  },
};

export default statuses;
